import { getImagePath, scrollTo } from '../helpers.js';
import { useRef, useEffect } from 'react';

function GallerySlide(props) {

  const imageNode = useRef(null);

  useEffect(() => {
    if (props.active) {
      // TODO: add header offset on mobile only
      scrollTo(document.documentElement, (imageNode.current.offsetTop), 100);
    }
  });


  return (
    <div ref={imageNode}>
      <img className="desktop" src={getImagePath(props.image, props.imageKey, 'large')} />
      <img className="mobile" src={getImagePath(props.image, props.imageKey, 'mobile')} />
    </div>
  );

}

export default GallerySlide;